import { ResponseParams, requestHttpPost } from './RequestBase';

type IssueConnectTokenResData = {
	connecttoken: string;
};
// セッションにあるアクセストークンから連携トークンを発行する
export const callIssueConnectTokenApi = async (
	scd: string,
	burl: string,
): Promise<ResponseParams<IssueConnectTokenResData>> => {
	const result: ResponseParams<IssueConnectTokenResData> = await requestHttpPost(`/connecttoken`, { scd, burl });
	return result;
};
